import React from 'react';
const MainContent = () => {
    return(
        <>
        <h1>Dashboard</h1>
        </>
    )
}
export default MainContent